import { render, staticRenderFns } from "./ActionReingreso.vue?vue&type=template&id=c19d5530&lang=pug"
import script from "./ActionReingreso.vue?vue&type=script&lang=js"
export * from "./ActionReingreso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports